export const XSRF_CUSTOM_COOKIE_NAME = 'FZW_XSRF_TOKEN';
export const XSRF_CUSTOM_HEADER_NAME = 'FZW_XSRF_HEADER';
